const state = {
  info: null
};

const mutations = {
  UPDATE_INFO_BANNER: (state, new_data) => {
    state.info = new_data;
  }
};

const actions = {
  update_info_banner(context, data) {
    context.commit("UPDATE_INFO_BANNER", data);
  }
};

export default {
  state,
  mutations,
  actions
};
